import { ModelRow } from "@mcleod/core";
import {AutogenLayoutFuelCardList} from "./autogen/AutogenLayoutFuelCardList";
import {DataSourceExecutionEvent, DropdownItem} from "@mcleod/components";

export class FuelCardList extends AutogenLayoutFuelCardList {

    override async onLoad() {
        const lmData = new ModelRow(this.textboxSearchStatus.lookupModel, false, { card_status: "A", card_status_desc: "Active" });
        this.mainDataSource.searchRow?.setValueAndLookupModelData("card_status", "A", lmData);
        this.mainDataSource.displayDataInBoundSearchComponent(this.textboxSearchStatus);
        this.mainDataSource.search(this.mainDataSource.searchRow);

        // Configure composite key handling for detail navigation
        // The fuel_card table has a 4-part composite primary key:
        // 1. id (card number)
        // 2. account_id
        // 3. sub_account
        // 4. fuel_interface_id
        // These must be comma-separated in the order defined by the primary key positions
        this.tableFuelCardList.determineDetailKeyValue = (tableRow) => {
            const modelRow = tableRow.data;
            const id = modelRow.getString("id");
            const accountId = modelRow.getString("account_id");
            const subAccount = modelRow.getString("sub_account");
            const fuelInterfaceId = modelRow.getString("fuel_interface_id");

            // Return comma-separated composite key matching primary key position order
            return `${id},${accountId},${subAccount},${fuelInterfaceId}`;
        };

        this.mainDataSource.addBeforeExecutionListener((event: DataSourceExecutionEvent) => {
            console.log("test")
        })
    }

}
